export default __webpack_public_path__ + "static/media/photo--lg--misc-17.d7780e7f.jpg";